import React from 'react'

import styles from './SingleLineCell/styles.less'

export default function CustomerCell({ value }) {
  return <div className={styles.SingleLineCell}>{value}</div>
}
